import React, { Component } from 'react'
import items from './data'
// import Client from './contentful'

// demo contentful fetch
// Client.getEntries({
//     content_type:'hotelResort'
// })
// .then(resp => console.log(resp.items))
// .catch(err => console.log(err))

const RoomContext = React.createContext();

class RoomProvider extends Component {
    state = {
        rooms: [],
        sortedRooms: [],
        featuredRooms: [],
        loading: true,
        type: 'all',
        capacity: 1,
        price: 0,
        minPrice: 0,
        maxPrice: 0,
        minSize: 0,
        maxSize: 0,
        breakfast: false,
        pets: false
    }

    // getData = async ()=>{
    //     try {
    //         let response = await Client.getEntries({
    //             content_type: 'hotelResort',
                    // sorting with when created
                    // order: 'sys.CreatedAt'
                    // or
                    // sorting with highest price
                    // order: '-field-price'
    //         })

    //         let rooms = this.formatData(response.items)
    //     // console.log(rooms)
    //     let featuredRooms = rooms.filter(room => room.featured === true)
    //     let maxPrice = Math.max(...rooms.map(item => item.price))
    //     console.log(maxPrice)
    //     let maxSize = Math.max(...rooms.map(item => item.size))
    //     console.log(maxSize)
    //     this.setState({
    //         rooms,
    //         featuredRooms, 
    //         sortedRooms: rooms,
    //         loading: false,
    //         price: maxPrice,
    //         maxPrice,
    //         maxSize,
    //     })

    //     } catch (error) {
    //         console.log(error);
    //     }
    // }

    // get data
    componentDidMount(){
        // this.getData()
        let rooms = this.formatData(items)
        // console.log(rooms)
        let featuredRooms = rooms.filter(room => room.featured === true)
        let maxPrice = Math.max(...rooms.map(item => item.price))
        console.log(maxPrice)
        let maxSize = Math.max(...rooms.map(item => item.size))
        console.log(maxSize)
        this.setState({
            rooms,
            featuredRooms, 
            sortedRooms: rooms,
            loading: false,
            price: maxPrice,
            maxPrice,
            maxSize,
        })
    }


    formatData(items){
        let tempItems = items.map(item => {
            let id = item.sys.id
            let images = item.fields.images.map(image => image.fields.file.url)
            let room = {...item.fields, images, id}
            return room
        })
        return tempItems
    }

    getRoom = (slug) =>{
        let tempRooms = [...this.state.rooms]
        const room = tempRooms.find(room => room.slug === slug)
        return room    
    }

    handleChange = e =>{
        // const value = e.target.value
        // const name = e.target.name 
        // const type = e.target.type
        // const terget = e.target
        // console.log(`this is type: ${type}, this is name: ${name},this is value: ${value}`)
        const name = e.target.name 
        const target = e.target
        const value = target.type === 'checkbox' ? target.checked : target.value
        this.setState({
            [name]: value
        },this.filterRooms)
    }
    
    filterRooms = ()=>{
        // console.log('yo')
        let{
            rooms,type,capacity,price,minSize,maxSize,breakfast,pets
        } = this.state
        // all the rooms
        let tempRooms = [...rooms]
        // parse people capacity value to int
        capacity = parseInt(capacity)
        // parse price value to int
        price = parseInt(price)
        // filter by type
        if(type !== 'all'){
            tempRooms = tempRooms.filter(room => room.type === type)
            // filter by capacity
        }
            if(capacity !== 1){
                tempRooms = tempRooms.filter(room => room.capacity >= capacity)
            }
            // filter by price
            tempRooms = tempRooms.filter(room => room.price <= price)

            // filter by size
            tempRooms = tempRooms.filter(room => room.size >= minSize && room.size <= maxSize)
            // filter by breakfast
            if(breakfast){
                tempRooms = tempRooms.filter(room => room.breakfast === true)
            }
            // filter by pets
            if(pets){
                tempRooms = tempRooms.filter(room => room.breakfast === true)
            }
            // change state
            this.setState({
                sortedRooms: tempRooms
            })
        
        // }else{
        //     this.setState({
        //         sortedRooms: 'all'
        //     })
        // }
    }

    render() {
        return (
            <RoomContext.Provider value={{...this.state, getRoom: this.getRoom, handleChange:this.handleChange }}>
                {this.props.children}
            </RoomContext.Provider>
        )
    }
}

const RoomConsumer = RoomContext.Consumer;

const withRoomConsumer = (Component)=>{
    return function consumerWrapper(props){
        return(
        <RoomConsumer>
            {value => <Component {...props} context={value} />}
        </RoomConsumer>
        )
    }
}

export {RoomProvider, RoomConsumer, RoomContext, withRoomConsumer}
